/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { useIntl } from 'react-intl'

import { EuiFlexGroup, EuiIconTip } from '@elastic/eui'

import type { OrganizationOption } from '@modules/organization-api'

import { useMarketplaceIcons } from '../lib'
import { messages } from '../messages'

export const OrganizationSuffix = ({
  enforceAuthenticationMethod,
  domain,
}: {
  enforceAuthenticationMethod: OrganizationOption['enforce_authentication_method']
  domain: OrganizationOption['domain']
}) => {
  const { formatMessage } = useIntl()
  const marketplaceIcons = useMarketplaceIcons()
  return (
    <EuiFlexGroup gutterSize='s' justifyContent='flexEnd' alignItems='center'>
      {enforceAuthenticationMethod && (
        <EuiIconTip
          type='key'
          aria-label={formatMessage(messages.reauthenticationRequired)}
          content={formatMessage(messages.reauthenticationRequired)}
          position='bottom'
        />
      )}
      {domain && marketplaceIcons[domain] && marketplaceIcons[domain].icon && (
        <EuiIconTip
          type={marketplaceIcons[domain].icon}
          aria-label={marketplaceIcons[domain].name}
          content={marketplaceIcons[domain].name}
          position='bottom'
        />
      )}
    </EuiFlexGroup>
  )
}
